import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import UseGetDashBoardData from "../../../../Components/Hooks/useDashboardData";
import UseGetDashBoardWithParams from "../../../../Components/Hooks/useDashboardDataParams";
import UseGetDashBoardParams from "../../../../Components/Hooks/useDashboardParams";


  

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-2 rounded shadow text-xs">
        <p className="font-bold">{label}</p>
        {payload.map((entry, index) => (
          <p key={index} className="text-xs" style={{ color: entry.color }}>
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};


function MonthlyWise() {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [overviewData, setOverviewData] = useState([]);
  const [params, setParams] = useState({
   
    year: currentYear,
  });

  const { data, loading } = UseGetDashBoardParams(`/dashboard/task-priority-summary`,params);

 

      useEffect(() => {
        if (data && Array.isArray(data)) {
          setOverviewData(data);
        }
      }, [data]);
    
       const handleYearChange = (e) => {
        const newYear = e.target.value;
        setParams({ ...params, year: newYear });
        setSelectedYear(newYear);
      };
    
  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg  flex flex-col">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-sm font-bold text-gray-800">Monthly Wise Task Priority</h2>
        <select
            value={selectedYear}
            onChange={handleYearChange}
            className="border rounded-md p-1 text-xs text-[#ACACAC] font-normal"
          >
            {[...Array(10)].map((_, index) => (
              <option key={index} value={currentYear - 5 + index}>
                {currentYear - 5 + index}
              </option>
            ))}
          </select>
      </div>

      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={overviewData} barGap={5} barCategoryGap={12}>
          <XAxis dataKey="month" tick={{ fontSize: 10 }} stroke="#888" />
          <YAxis tick={{ fontSize: 10 }} stroke="#888" />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "none" }} />
          <Legend wrapperStyle={{ fontSize: '10px' }} />
          <Bar dataKey="high" fill="#EF4444" name="High" barSize={10} radius={[4, 4, 0, 0]} />

          <Bar dataKey="medium" fill="#F59E0B" name="Medium" barSize={10} radius={[4, 4, 0, 0]} />
          <Bar dataKey="low" fill="#60A5FA" name="Low" barSize={10} radius={[4, 4, 0, 0]} />

        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default MonthlyWise;
